import React from 'react';
import MinimumOffer from '../MinimumOffer';
import Countdown from '../Countdown';
import s from './MinOfferAndCountdown.scss';
const MinOfferAndCountdown = ({ adoptableState: { earlyAccess, minOfferPrice, countdownHasEnded, onTimerEnd, countdownEndTime } })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(MinimumOffer, {
        value: minOfferPrice
    }), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Countdown, {
        isEarlyAccess: earlyAccess.isInEarlyAccess,
        hasEnded: countdownHasEnded,
        countToDate: countdownEndTime,
        onEnd: onTimerEnd
    }));
};
MinOfferAndCountdown.displayName = 'MinOfferAndCountdown';
export default MinOfferAndCountdown;

//# sourceMappingURL=MinOfferAndCountdown.js.map